import { ref } from 'vue';
import { defineStore } from 'pinia'

// what is computed? 

export const usePlayerStore = defineStore('player', () => {
	const currentTrack = ref({})
	
	return { currentTrack }
})